const template=`
<div class="widgetDateRange momentumDateRange">
  <div class="dateRange">
    <div><span class="translate rangeLabel">Current</span><span class="rangeLabel">: </span><span>{{getDateRange('current')}}</span></div>
    <div><span class="translate rangeLabel">Previous</span><span class="rangeLabel">: </span><span>{{getDateRange('previous')}}</span></div>
  </div>
</div>
<div class="widgetDetails">
  <div class="widgetContentMax insWidgetMax">
    <widget-status></widget-status>
    <div>
      <h3 class="widgetNoResultsLabel translate" ng-show="noContent &amp;&amp; !widgetIsLoading">No results</h3>
    </div>
    <momentum-d3 class="bubble" data="chartData" chart-type="graphType" selected="selectedNodes" drill="drill(id)" maximized="isMaximized" data-ng-hide="widgetIsLoading || serviceError || noContent || notConfigured" is-report="isReport" export-type="exportType"></momentum-d3>
  </div>
</div>`;
export default template;
